import { Box, Typography } from "@mui/material";
import React, { useState, useEffect } from "react";
import { getApiWithAuth } from "../utils/api";
import { ALL_NEW_DRIVERS } from "../utils/apiUrl";
import NewDriverOverview from "../components/driversPageCompo/NewDriverOverview";
import NewTopbar from "../components/driversPageCompo/NewTopbar";

const NewDriverPage = () => {
  const [drivers, setDrivers] = useState([]);
  const [filteredDrivers, setFilteredDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch drivers from API
  useEffect(() => {
    const fetchDrivers = async () => {
      try {
        const response = await getApiWithAuth(ALL_NEW_DRIVERS);
        if (response && Array.isArray(response.data.data)) {
          setDrivers(response.data.data);
          setFilteredDrivers(response.data.data);
        } else {
          console.error("Unexpected data format:", response);
        }
        setLoading(false);
      } catch (err) {
        console.error("Error fetching drivers:", err);
        setError(err);
        setLoading(false);
      }
    };

    fetchDrivers();
  }, []);

  // Search function to filter drivers
  const handleSearch = (query) => {
    const lowerCaseQuery = query.toLowerCase();

    const filtered = drivers.filter((driver) => {
      // Check if the value is null or undefined before calling .toLowerCase() or .includes()
      const firstNameMatch = driver.first_name
        ? driver.first_name.toLowerCase().includes(lowerCaseQuery)
        : false;

      const lastNameMatch = driver.last_name
        ? driver.last_name.toLowerCase().includes(lowerCaseQuery)
        : false;

      const cellNumberMatch = driver.number
        ? driver.number.includes(query)
        : false;

      return firstNameMatch || lastNameMatch || cellNumberMatch;
    });

    setFilteredDrivers(filtered);
  };

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  if (error) {
    return <Typography>Error: {error.message}</Typography>;
  }

  if (!Array.isArray(filteredDrivers)) {
    console.error("Drivers data is not an array:", filteredDrivers);
    return <Typography>Error: Unexpected data format</Typography>;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <NewTopbar onSearch={handleSearch} />
      {filteredDrivers.map((driver, index) => (
        <NewDriverOverview
          key={driver.id}
          driver={driver}
          index={index}
          showActive={driver.isactive}
        />
      ))}
    </Box>
  );
};

export default NewDriverPage;
